<template>
  <div class="flex flex-col">
    <label for="job_description" class="mb-1 font-medium">
      Description<span class="text-red-500">*</span>
    </label>
    <input
      id="job_description"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      type="text"
      required
      maxlength="100"
      :class="[
        'border rounded px-3 py-2 focus:outline-none focus:ring-2 dark:bg-gray-600',
        error ? 'border-red-500 ring-2 ring-red-500' : 'border-gray-300 focus:ring-blue-500',
      ]"
    />
    <FieldError :message="error" />
    <p v-if="staffJobName" class="text-sm text-gray-500 dark:text-gray-400 mt-1">Job name: {{ staffJobName }}</p>
  </div>
</template>

<script>
import FieldError from "@/components/FieldError.vue";
import { useStore } from "@/store";

export default {
  name: "JobDescriptionInput",
  components: { FieldError },
  props: {
    modelValue: { type: String, default: "" },
    error: { type: String, default: "" },
    jobName: { type: String, default: "" },
  },
  emits: ["update:modelValue"],
  computed: {
    staffJobName() {
      return useStore.getUser()?.is_staff ? this.jobName : "";
    },
  },
};
</script>
